export class Worker {
    MemberId: number;
    LastName: string;
    FirstName: string;
    UserId: number;
    UserTypeId: number;
    BusinessId: number;
    stringWorkerId: string;
    businessName: string;
    businessAlias: string;
    ConsentNotificationReceived: boolean = false;
    IsNewrelicEnable: boolean = false;
 
   constructor(memberId: number, lastName: string, firstName: string, userId: number, userTypeId: number, businessId: number, stringWorkerId: string, businessName: string, businessAlias: string, consentNotificationReceived: boolean | string, isNewrelicEnable: boolean | string) {     
    this.MemberId = memberId;
    this.LastName = lastName;
    this.FirstName = firstName;    
    this.UserId = userId;
    this.UserTypeId = userTypeId;
    this.BusinessId = businessId;
    this.stringWorkerId = stringWorkerId;
    this.businessName = businessName;
    this.businessAlias = businessAlias;
    this.ConsentNotificationReceived = consentNotificationReceived === true || consentNotificationReceived === "1";
    this.IsNewrelicEnable = isNewrelicEnable === true || isNewrelicEnable === "1";
  }
}